import React from 'react';

import { BaseIconProps } from './';

export const Hamburger = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.1556886,0,0,-2.1556886,-4.3113715,1092.9341)"
    d="m 2,436 v -44 h 501 v 44 z M 2,234 h 501 v 45 H 2 Z M 2,77 h 501 v 44 H 2 Z"
    fill={fill}
  />
);
